import React from "react";

/**
 * BETA MODE — closed beta (6-12 months).
 *
 * Inert during beta. All authenticated users receive Premium access for
 * free, so we render nothing instead of the original upgrade-prompt card.
 *
 * `LockedFeature` and the default `Upgrade` export are both kept (as
 * no-ops) for backwards compatibility with existing call sites in
 * AiInsightsPage.js, BestValuePage.js, etc.
 */
const Upgrade = () => null;

export const LockedFeature = () => null;

export default Upgrade;
